import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

function RegisterPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await axios.post('http://localhost:3001/register', { username, password });
      alert('Rekisteröinti onnistui! Kirjaudu sisään.');
      navigate('/login');
    } catch (error) {
      console.error('Registration failed', error);
      alert('Rekisteröinti epäonnistui');
    }
  };

  return (
    <div>
      <h2>Rekisteröidy</h2>
      <form onSubmit={handleRegister}>
        <input
          type="text"
          placeholder="Käyttäjätunnus"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Salasana"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Rekisteröidy</button>
      </form>
      <Link to="/login">
        <button type="button">Siirry kirjautumiseen</button>
      </Link>
    </div>
  );
}

export default RegisterPage;
